import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      title={isLight ? "Switch to dark mode" : "Switch to light mode"}
      className={`btn-ghost flex items-center justify-center gap-2 text-sm ${className}`}
    >
      {isLight ? <Moon size={15} /> : <Sun size={15} />}
      {isLight ? "Dark mode" : "Light mode"}
    </button>
  );
}
